module.exports = __webpack_public_path__ + "static/avd-ac39d3524c3a706a37b7d20cc5717dd8.svg";